import { getSubmissionAttributionData } from "../utils/attribution.util";

interface SubmissionCreateData {
  provider_id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  sms_consent?: number;
  filter_age?: string;
  filter_gender?: string;
  filter_location?: string;
  categories_selected?: string;
  selected_class_name?: string;
  selected_class_id?: string;
  funnel_type?: string;
  funnel_last_step?: string;
  ghl_status?: string;
  page_url?: string;
  visitor_id?: string;
  attribution_data?: any;
}

interface SubmissionUpdateData {
  categories_selected?: string;
  selected_class_name?: string;
  selected_class_id?: string;
  selected_class_day?: string;
  selected_class_time?: string;
  selection_type?: string;
  funnel_type?: string;
  ghl_status?: string;
  ghl_contact_id?: string;
  ghl_response?: any;
  ghl_request?: any;
  funnel_last_step?: string;
  funnel_completed?: number;
}

const STORAGE_KEY = "ryb_submission_id";

class SubmissionService {
  private static instance: SubmissionService;
  private submissionId: string | null = null;
  private submissionSessionId: string | null = null;
  private baseUrl: string = "";

  constructor() {
    if (SubmissionService.instance) {
      return SubmissionService.instance;
    }
    SubmissionService.instance = this;
    this.baseUrl = `https://${window.location.host}/wp-json/ryb/v1/submissions`;
    this.submissionId = sessionStorage.getItem(STORAGE_KEY);
  }

  static getInstance(): SubmissionService {
    if (!SubmissionService.instance) {
      new SubmissionService();
    }
    return SubmissionService.instance;
  }

  getSubmissionId(): string | null {
    return this.submissionId;
  }

  getSubmissionSessionId(): string | null {
    return this.submissionSessionId;
  }

  async createSubmission(data: SubmissionCreateData): Promise<string | null> {
    try {
      const utmData = getSubmissionAttributionData();
      const payload = {
        ...utmData,
        ...data,
        page_url: data.page_url || window.location.href,
      };

      const response = await $.ajax({
        url: `${this.baseUrl}?timestamp=${Date.now()}`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
      });

      if (response?.success && response?.data?.id) {
        const id = String(response.data.id);
        const sessionId = response?.data?.session_id
          ? String(response.data.session_id)
          : null;

        this.submissionId = id;
        sessionStorage.setItem(STORAGE_KEY, id);
        if (sessionId) {
          this.submissionSessionId = sessionId;
        } else {
          this.submissionSessionId = null;
        }
        return id;
      }
      return null;
    } catch (error) {
      console.error("Failed to create submission:", error);
      return null;
    }
  }

  async updateSubmission(data: Partial<SubmissionUpdateData>): Promise<void> {
    if (!this.submissionId) return;

    try {
      await $.ajax({
        url: `${this.baseUrl}/${this.submissionId}?timestamp=${Date.now()}`,
        method: "PUT",
        contentType: "application/json",
        headers: this.submissionSessionId
          ? { "X-RYB-Submission-Session": this.submissionSessionId }
          : undefined,
        data: JSON.stringify(data),
      });
    } catch (error) {
      console.error("Failed to update submission:", error);
    }
  }
}

export const submissionService = SubmissionService.getInstance();
